export default {
  "list": "_list_d7lqp_1"
};import "ni:sha-256;6oq9CqU1jS76ZB1Ts9TLy7iIVupFUb4fofpY8qN-QjM";